<template>
  <div class="pageStyle" @touchstart="touchstart" @touchmove="touchmove">
    <!-- 地图 -->
    <div class="map">
      <div id="mapContainer"></div>
    </div>
    <!-- 企业列表 -->
    <div class="companyList">
      <div class="btn">
        <div @click="toPage('accurateSearch')">
          <img
            src="https://static.xchengtech.cn/2d03892d1220457d85c0f2e86829661c.png"
            alt=""
          /><span>精准搜索</span>
        </div>
        <!-- <div @click="toPage('batchSearch')"> 
          <img
            src="https://static.xchengtech.cn/ee93ef72e04240b79d32d262df872668.png"
            alt=""
          /><span>批量反查</span>
        </div> -->
        <!-- <div @click="toPage('collectList')">
              <img
                src="https://static.xchengtech.cn/8c70056d56f045748092c18f93e6e7ea.png"
                alt=""
              /><span>收藏列表</span>
            </div> -->
      </div>
      <div class="companyList-box">
        <!-- 小边框 -->
        <div class="smallBorder">
          <div class="topBorder" @click="scrollToDiv('companyList')">
            <span></span>
          </div>
        </div>
        <div class="content">
          <div
            @click="moveTo(item)"
            class="item"
            v-for="(item, index) in companyList"
            :key="index"
          >
            <div class="row">
              <!-- 企业名称 -->
              <div class="left">
                <span>{{ index + 1 }}.</span>
                <span>{{ item.companyName }}</span>
              </div>
              <div
                @click.stop="addCustomer(item.id, item.isFavorite)"
                class="right star"
              >
                <!-- 未收藏图标 -->
                <img
                  :src="
                    item.isFavorite === true
                      ? favoriteIcon.haved
                      : favoriteIcon.no
                  "
                  alt=""
                />
              </div>
            </div>
            <div class="row">
              <span>企业税号：</span>
              <span>{{ item.creditCode }}</span>
            </div>
            <div class="row">
              <div class="left">
                <div>
                  <span>成立时间：</span>
                  <span>
                    {{ item.establishTime }}
                  </span>
                </div>
                <div>
                  <span>注册资本：</span>
                  <span>
                    {{ item.registeredCapital }}
                  </span>
                </div>
                <div>
                  <span>所属行业：</span>
                  <span>
                    {{ item.industry1 ? item.industry1 + "、" : ""
                    }}{{ item.industry2 ? item.industry2 + "、" : ""
                    }}{{ item.industry3 ? item.industry3 : "" }}
                  </span>
                </div>
                <div>
                  <span>注册地址：</span>
                  <span>
                    {{ item.registeredAddress }}
                  </span>
                </div>
              </div>
              <div class="right">
                <span>{{ item.distance }}</span>
                <span>公里</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 置顶 -->
    <img
      @click="scrollToDiv"
      ref="toTopIcon"
      class="toTopIcon"
      src="https://static.xchengtech.cn/a46667761b5e4cb78dd1cd3b2c4257ef.png"
      alt=""
    />
  </div>
</template>

<script>
import Vue from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";
import { getLocation } from "@/utils/wxJsSdk";
import { getSdk, fillLog } from "@/api/wx";
import { setMarker } from "@/utils/map";
import { isDevelopment } from "@/utils/index";
import { loadNearPoint } from "@/api/companyInfo";
import { Toast, Notify } from "vant";
import { getCurrentChannelInfo } from "@/api/login.js";
import {
  getFavoriteStatus,
  addCustomer,
  delXcCustomer,
} from "@/api/xcCustomer";
Vue.use(Toast);
export default {
  name: "XcExhibitionSystemIndex",

  data() {
    return {
      favoriteIcon: {
        haved:
          "https://static.xchengtech.cn/3ee9bbf4f0a940dc989f8b434db656da.png",
        no: "https://static.xchengtech.cn/35616b4a838b487e8df7da4b03f2f2d0.png",
      },
      ll: {},
      map: null,
      companyList: [],
      markerList: [],
      // 是否创建了图层
      layerIsCreated: false,
      // 页面滑动时的数据
      startY: "",
      moveY: "",
      // 地图点击企业时 保存的企业信息
      areaClickCompanyMsg: {},
      // 收藏列表
      userFavoriteList: [],
      channelInfo: {},
    };
  },

  created() {
    //latitude: 22.26666, longitude: 113.54342
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "加载中",
    });
    if (isDevelopment()) {
      this.ll = {
        longitude: 113.54342,
        latitude: 22.26666,
      };
      this.initAMap(this.ll);
    } else {
      getLocation()
        .then((res) => {
          let ll = {
            longitude: res.longitude,
            latitude: res.latitude,
          };
          this.ll = ll;
          this.initAMap(ll);
        })
        .catch((err) => {
          this.initAMap(null);
          console.log("err", err);
          Toast.clear();
        });
    }
    // 获取渠道用户信息
    getCurrentChannelInfo().then((res) => {
      this.channelInfo = res;
    });

    //
  },

  methods: {
    initAMap(LL) {
      AMapLoader.load({
        key: "8270d864149c654fc643a9d13e7df60b", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          if (LL == null) {
            this.map = new AMap.Map("mapContainer", {
              viewMode: "3D", // 是否为3D地图模式
              zoom: 16, // 初始化地图级别
            });
            // 等待地图加载完成
            let that = this
            this.map.on("complete", function () {
              
              var center = that.map.getCenter();
              
              that.ll = {
                longitude: center.getLng(),
                latitude: center.getLat(),
              };
              //载入点
              that.loadPoint();
              //添加移动事件
              that.addMoveEven();
            });
          } else {
            //初始化地图
            this.map = new AMap.Map("mapContainer", {
              // 设置地图容器id
              viewMode: "3D", // 是否为3D地图模式
              zoom: 16, // 初始化地图级别
              center: [LL.longitude, LL.latitude], // 初始化地图中心点位置
            });
            //载入点
            this.loadPoint();
            //添加移动事件
            this.addMoveEven();
          }
        })

        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    loadPoint() {
      let layer = new AMap.LabelsLayer({
        zooms: [3, 20],
        zIndex: 1000,
        // collision: false,
        // 设置 allowCollision：true，//可以让标注避让用户的标注
        allowCollision: true,
      });
      //载入附近的点
      // Toast.loading({
      //   duration: 0, // 持续展示 toast
      //   forbidClick: true,
      //   message: "加载中",
      // });
      loadNearPoint(this.ll)
        .then((res) => {
          //添加到企业列表
          this.pushToCompanyList(res);
          //判断是否收藏
          this.fetchFavoriteStatus();
          //创建点标
          let markers = this.createMarker(res);
          //创建图层，并写入map
          this.createLayerAndRenderMap(markers, layer);
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    pushToCompanyList(res) {
      //如果res.id 不存在companyList中，则添加进去
      res.forEach((element) => {
        let isExist = false;
        this.companyList.forEach((item) => {
          if (item.id == element.id) {
            isExist = true;
          }
        });
        if (!isExist) {
          element.distance = this.distance(this.ll, element);
          this.companyList.push(element);
        }
      });
      this.sortCompanyList();
    },
    distance(ll, element) {
      //根据坐标计算距离

      var dLat = element.latitude - ll.latitude;
      var dLon = element.longitude - ll.longitude;

      //单位为公里
      let distance = Math.sqrt(dLat * dLat + dLon * dLon);
      return (distance * 1000).toFixed(2);
    },
    addClickEven(marker) {
      let that = this;

      marker.on("click", function () {
        let msg = that.findCompanyInfoById(marker._opts.extData.id);
        //todo 按需组成的信息窗口内容
        let infoWindow = new AMap.InfoWindow({
          content: that.getWindowContent(msg),
          offset: new AMap.Pixel(0, -30),
        });
        // 打开企业小弹窗
        infoWindow.open(that.map, marker.getPosition());
        // 给小弹窗添加点击事件
        that.bindWinClickEven();
      });
    },
    bindWinClickEven() {
      const spanElements = document.querySelectorAll(
        "span[name='windowFavor']"
      );
      let that = this;
      // 遍历并绑定点击事件
      spanElements.forEach(function (span) {
        span.addEventListener("click", function () {
          let enterpriseId = span.getAttribute("id");
          // 判断是否已收藏
          let index = that.userFavoriteList.indexOf(enterpriseId);
          // 如果企业收藏了，则取消收藏
          if (index > -1) {
            // 取消收藏
            that.addCustomer(enterpriseId, true);
            that.userFavoriteList.splice(index, 1);
            let msg = that.findCompanyInfoById(enterpriseId);
            // 使用移动方法创建新视图
            that.moveTo(msg);
          } else {
            that.addCustomer(enterpriseId);
          }
          // 点亮收藏图标
          span.querySelectorAll("img")[0].src =
            "https://static.xchengtech.cn/3ee9bbf4f0a940dc989f8b434db656da.png";
        });
      });
    },
    addMoveEven() {
      let that = this;
      this.map.on("moveend", function () {
        let center = that.map.getCenter();
        that.ll = { longitude: center.lng, latitude: center.lat };
        that.loadPoint();
      });
    },
    findCompanyInfoById(id) {
      for (let i = 0; i < this.companyList.length; i++) {
        const element = this.companyList[i];
        if (element.id == id) {
          return element;
        }
      }

      return false;
    },
    findMarkerById(id) {
      for (let i = 0; i < this.markerList.length; i++) {
        const element = this.markerList[i];
        if (element._opts.extData.id == id) {
          return element;
        }
      }

      return false;
    },
    toPage(name) {
      this.$router.push({ path: "/" + name });
    },
    fetchFavoriteStatus() {
      getFavoriteStatus()
        .then((res) => {
          // 用户收藏列表
          this.userFavoriteList = res;
          //获取enterpriseIdList，与companyList进行对比，如果存在则设置isFavorite为true
          // 点亮企业列表里的收藏按钮
          for (let i = 0; i < this.companyList.length; i++) {
            const enterpriseId = this.companyList[i].id;
            for (let j = 0; j < res.length; j++) {
              if (res[j] === enterpriseId) {
                this.$set(this.companyList[i], "isFavorite", true);
              }
            }
          }
          Toast.clear();
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    addCustomer(id, isFavorite) {
      // 如果是已收藏，则取消收藏
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });

      if (isFavorite === true) {
        delXcCustomer(this.channelInfo.id, id)
          .then((res) => {
            Notify({ type: "success", message: "已取消收藏" });
            // 取消点亮
            let o = this.companyList.findIndex((item) => {
              return item.id == id;
            });
            this.companyList[o].isFavorite = false;
            Toast.clear();
          })
          .catch((err) => {
            Toast.clear();
            console.log("err", err);
          });
      }
      //
      else {
        let customer = {
          enterpriseId: id,
          resourceType: "development",
        };

        addCustomer(customer)
          .then((res) => {
            Toast.clear();
            Notify({ type: "success", message: "收藏成功" });
            // 重新获取已收藏列表 且点亮图标
            this.fetchFavoriteStatus();
            //点亮图标
            // for (let i = 0; i < this.companyList.length; i++) {
            //   if (this.companyList[i].id == id) {
            //     this.$set(this.companyList[i], "isFavorite", true);
            //   }
            // }
          })
          .catch((err) => {
            Toast.clear();
            console.log("err", err);
          });
      }
    },
    moveTo(item) {
      let targetLngLat = [item.longitude, item.latitude];
      let point = new AMap.LngLat(targetLngLat[0], targetLngLat[1]);
      this.map.setCenter(point, { duration: 1000 });
      window.scrollTo({
        top: 0, // 滚动到页面顶部
        behavior: "smooth", // 平滑滚动效果
      });
      let msg = this.findCompanyInfoById(item.id);
      //todo 按需组成的信息窗口内容
      let infoWindow = new AMap.InfoWindow({
        content: this.getWindowContent(msg),
        offset: new AMap.Pixel(0, -30),
      });

      infoWindow.open(this.map, point);
      // 给小弹窗添加点击事件
      this.bindWinClickEven();
    },
    createMarker(res) {
      let markers = [];
      for (var i = 0; i < res.length; i++) {
        let element = res[i];
        let marker = setMarker({
          name: element.companyName,
          latitude: element.latitude,
          longitude: element.longitude,
          content: element.companyName,
          index: i,
          id: element.id,
        });
        let labelMarker = new AMap.LabelMarker(marker);
        this.addClickEven(labelMarker);
        markers.push(labelMarker);
      }
      return markers;
    },
    sortCompanyList() {
      this.companyList.sort((a, b) => {
        return a.distance - b.distance;
      });
    },
    createLayerAndRenderMap(markers, layer) {
      if (this.layerIsCreated) {
        //图层已经创建过了，追加点
        for (let i = 0; i < markers.length; i++) {
          //检查标记点是否已经存在
          if (!this.findMarkerById(markers[i]["_opts"]["extData"].id)) {
            this.map.add(markers[i]);
            this.markerList.push(markers[i]);
          }
        }
      } else {
        layer.add(markers);
        //保存已添加的markers
        this.markerList.concat(markers);
        // 图层添加到地图
        this.map.clearMap();
        this.map.add(layer);
        this.layerIsCreated = true;
      }
    },
    getWindowContent(msg) {
      this.areaClickCompanyMsg = msg;
      let businessStatus = msg.businessStatus ? msg.businessStatus : "";
      let companyType = msg.companyType ? msg.companyType : "";
      // 判断小地图企业是否已收藏
      if (this.userFavoriteList.indexOf(msg.id) > -1) {
        return (
          `
          <div style="font-size: 3.6vw;""><div style="font-weight: 600;
  font-size: 4vw;">` +
          msg.companyName +
          `</div><div style="font-size: 3.6vw;">` +
          msg.creditCode +
          `</div><div style="display: flex;
  align-items: center;
  gap: 1vw;">` +
          businessStatus +
          ` ` +
          companyType +
          `</div><div   style="    display: flex;
    justify-content: right;"  ><span name = "windowFavor" id = "` +
          msg.id +
          `"    style="display: inline-flex;
    align-items: center;
    gap: 1vw;
    border: 1px solid #efefef;
    padding: 2px 6px;
    font-size: 3.6vw;"><img style="display: block;

  width: 3vw;
  height: 3vw;"
                  src="https://static.xchengtech.cn/3ee9bbf4f0a940dc989f8b434db656da.png"
                  alt=""
                />已收藏</span></div></div>
          `
        );
      } else {
        return (
          `
          <div style="font-size: 3.6vw;""><div style="font-weight: 600;
  font-size: 4vw;">` +
          msg.companyName +
          `</div><div style="font-size: 3.6vw;">` +
          msg.creditCode +
          `</div><div style="display: flex;
  align-items: center;
  gap: 1vw;">` +
          businessStatus +
          ` ` +
          companyType +
          `</div><div   style="    display: flex;
    justify-content: right;"  ><span name = "windowFavor" id = "` +
          msg.id +
          `"    style="display: inline-flex;
    align-items: center;
    gap: 1vw;
    border: 1px solid #efefef;
    padding: 2px 6px;
    font-size: 3.6vw;"><img style="display: block;

  width: 3vw;
  height: 3vw;"
                  src="https://static.xchengtech.cn/35616b4a838b487e8df7da4b03f2f2d0.png"
                  alt=""
                />收藏</span></div></div>
          `
        );
      }
    },
    scrollToDiv(divId) {
      // var div = document.getElementById(divId);
      // div.scrollIntoView({ behavior: "smooth", block: "start" });
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    // 屏幕滑动事件
    touchstart(e) {
      this.startY = e.touches[0].clientY;
    },
    touchmove(e) {
      this.moveY = e.touches[0].clientY;
      if (this.startY - this.moveY <= 0) {
        // 从上往下拉 显示
        this.$refs["toTopIcon"].style.right = "4vw";
      } else {
        // 从下往上拉 隐藏
        this.$refs["toTopIcon"].style.right = "-6vw";
      }
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/customerCenter/index.vue